import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { classesBouton } from '@journal/ui';

/**
 * Lien de navigation ayant l'aspect d'un bouton.
 *
 * Reste un `<a>` : c'est une navigation, pas une action. Un `<button>` qui
 * appelle `navigate()` casse le clic du milieu, l'ouverture dans un nouvel
 * onglet, la copie d'adresse et le bouton Retour — quatre gestes qu'on fait
 * sans y penser, et dont l'absence passe pour une panne.
 *
 * Les classes viennent de `classesBouton` plutôt que d'être recopiées ici :
 * une retouche du bouton doit se voir partout du même coup.
 */
export function LienBouton({
  vers, children, variante = 'primary', taille = 'md', icone,
}: {
  vers: string;
  children: ReactNode;
  variante?: 'primary' | 'secondary' | 'ghost' | 'danger' | 'discret';
  taille?: 'sm' | 'md' | 'lg';
  /** Icône placée AVANT le libellé. Décorative : le texte reste obligatoire. */
  icone?: ReactNode;
}) {
  return (
    <Link to={vers} className={classesBouton({ variante, taille })}>
      {icone}
      {children}
    </Link>
  );
}
